 /* eslint-disable */ 
 let tag= process.env.VUE_APP_TAG
 let new_service_basis=getEnv(tag).service_basis


export default {
    // 实训目录-实训数据集详情
    /**
     * 新增数据集
     */
    addDataset: `${new_service_basis}/ai/training/tagProject/addDataset`,
    /**
     * 通过实训id获取数据集信息
     */
    getDatasetByTrainingId: `${new_service_basis}/ai/training/tagProject/getDatasetByTrainingId`,
    /**
     * 通过数据集id获取数据集状态
     */
    getDatasetStatusByDatasetId: `${new_service_basis}/ai/training/tagProject/getDatasetStatusByDatasetId`,
    /**
     * 新增标签
     */
    addDatasetLabel: `${new_service_basis}/ai/training/tagProject/addDatasetLabel`,
    /**
     * 通过数据集id获取标签
     */
    getLabelByDatasetId: `${new_service_basis}/ai/training/tagProject/getLabelByDatasetId`,
    /**
     * 修改标签
     */
    updateDatasetLabel: `${new_service_basis}/ai/training/tagProject/updateDatasetLabel`,
    /**
     * 删除标签
     */
    deleteDatasetLabel: `${new_service_basis}/ai/training/tagProject/deleteDatasetLabel`,
    /**
     * 上传文件
     */
    addDatasetFile: `${new_service_basis}/ai/training/tagProject/addDatasetFile`,
    /**
     * 通过标签id获取图片
     */
    getFileByLabelId: `${new_service_basis}/ai/training/tagProject/getFileByLabelId`,
    /**
     * 修改文件
     */
    updateDatasetFile: `${new_service_basis}/ai/training/tagProject/updateDatasetFile`,
    /**
     * 删除文件
     */
    deleteDatasetFile: `${new_service_basis}/ai/training/tagProject/deleteDatasetFile`,
    /**
     * 上传目标文件
     */
    addTrainingTargetFile: `${new_service_basis}/ai/training/tagProject/addTrainingTargetFile`,
    /**
     * 通过实训id获取目标文件
     */
    getTargetFileByTraining: `${new_service_basis}/ai/training/tagProject/getTargetFileByTraining`,
    /**
     * 修改目标文件
     */
    updateTrainingTargetFile: `${new_service_basis}/ai/training/tagProject/updateTrainingTargetFile`,
    /**
     * 删除目标文件
     */
    deleteTrainingTargetFile: `${new_service_basis}/ai/training/tagProject/deleteTrainingTargetFile`,
    /**
     * 创建模型
     */
    insertModel: `${new_service_basis}/ai/training/tagProject/insertModel`,
    /**
     * 获取模型
     */
    getModelByTrainingId: `${new_service_basis}/ai/training/tagProject/getModelByTrainingId`,
    /**
     * 根据数据集id查询标签下的数量
     */
    getLabelNumByDatasetId: `${new_service_basis}/ai/training/tagProject/getLabelNumByDatasetId`,
    /**
     * 新增训练模型
     */
    addTrainModel: `${new_service_basis}/ai/training/tagProject/addTrainModel`,
    /**
     * 查询训练模型版本信息
     */
    getTrainModelByModelId: `${new_service_basis}/ai/training/tagProject/getTrainModelByModelId`,
    /**
     * 删除训练模型
     */
    deleteTrainingModel: `${new_service_basis}/ai/training/tagProject/deleteTrainingModel`,
    /**
     * 发布训练模型
     */
    releaseTrainModel: `${new_service_basis}/ai/training/tagProject/releaseTrainModel`,
    /**
     * 校验模型
     */
    verifyModel: `${new_service_basis}/ai/training/tagProject/verifyModel`,

    /**
     * 老师查看学生校验结果、学生查看老师校验结果
     */
    getCheckDataByTrainModelId: `${new_service_basis}/ai/training/tagProject/getCheckDataByTrainModelId`,

    // 物体检测-标注数据接口
    /**
     * 通过数据集id获取文件
     */
    getFileByDatasetId: `${new_service_basis}/ai/training/tagProject/getFileByDatasetId`,
    /**
     * 根据标签ids查询文件列表
     */
    getFileByLabelIds: `${new_service_basis}/ai/training/tagProject/getFileByLabelIds`,
    /**
     * 根据图片id查询图片标注数据
     */
    getImgTagByImgId: `${new_service_basis}/ai/training/tagProject/getImgTagByImgId`,
    /**
     * 根据图片id标注图片
     */
    updateImgTagByImgId: `${new_service_basis}/ai/training/tagProject/updateImgTagByImgId`,
    /**
     * 根据标签id查询标注数量
     */
    getTagNumByLabelIds: `${new_service_basis}/ai/training/tagProject/getTagNumByLabelIds`,

    // 实训作业接口 //
    /**
     * 通过实训id获取项目作业数据
     */
    getTaskByTrainingId: `${new_service_basis}/ai/training/task/getTaskByTrainingId`,
    /**
     * 查询基础项目作业详情数据
     */
    getTaskInfoByTrainingId: `${new_service_basis}/ai/training/task/getTaskInfoByTrainingId`,
    /**
     * 老师评价学生已提交项目
     */
    evaluationProByTeacher: `${new_service_basis}/ai/training/task/evaluationProByTeacher`,
    /**
     * 数据标注项目添加学生自评
     */
     saveEvaluation: `${new_service_basis}/ai/training/tagProject/saveEvaluation`,
    /**
     * 获取实训报
     */
    getTrainingReport: `${new_service_basis}/ai/training/task/getTrainingReport`,

    // 实训考核接口 //
    /**
     * 添加项目考核标准
     */
    addTrainingCheck: `${new_service_basis}/ai/training/tagProject/addTrainingCheck`,
    /**
     * 老师查看项目考核标准
     */
    getTrainingCheck: `${new_service_basis}/ai/training/tagProject/getTrainingCheck`,
    /**
     * 学生查看实训考核
     */
    getTrainingCheckByStudent: `${new_service_basis}/ai/training/tagProject/getTrainingCheckByStudent`,
    /**
     * 删除项目考核标准
     */
    deleteTrainingCheck: `${new_service_basis}/ai/training/tagProject/deleteTrainingCheck`,
    /**
     * 老师、学生查看评分实训考核结果
     */
    getTrainingAssessReport: `${new_service_basis}/ai/training/task/getTrainingAssessReport`,
    /**
     * 已设置实训考核-老师评分
     */
    evaluationAssessByTeacher: `${new_service_basis}/ai/training/task/evaluationAssessByTeacher`,
}
